






















import { get, method } from 'lodash';
import CoAlert from '@/components/Molecules/co-alert/CoAlert.vue';

export default {
    name: 'PermanentBanView',
    components: {
        CoAlert,
    },
    methods: {
        get,
    },
};
